import { Component, Input, OnInit } from '@angular/core';
import { CompanyParamsService } from 'src/app/core/services/company-params.service';
import { right } from "@popperjs/core";
import { DecimalPipe } from '@angular/common';

@Component({
    selector: 'app-rating',
    templateUrl: './rating.component.html',
    styleUrls: ['./rating.component.scss'],
    imports: [DecimalPipe]
})
export class RatingComponent implements OnInit {

  @Input() name: string;
  @Input() rating: number;
  @Input() size: string = "small| medium | large";
  @Input() align: string = "left | right"

  constructor(public companyParamsService: CompanyParamsService) {
    this.rating = 0;
    this.name = "Rating";
    this.align = right;
  }

  ngOnInit(): void {
  }

  getClass(): string {
    return `width: ${(this.rating * 100 / 5)}%`
  }

  getStyleSize(): string {
    if (this.size == 'small') return `width: 80px; height: 13px;margin-top: 4px;`;
    return `width: 150px;`;
  }

  getStyleSizeFont(): string {
    if (this.size == 'small') return `font-size: 13px;`;
    return `font-size: 15px;`;
  }

  getStyleSizeFontRating(): string {
    if (this.size == 'small') return ` margin-top:4px; height: 13px; width: 23px;padding-left: 4px;border-radius: 4px;font-size: 10px;background-color:#${this.companyParamsService.getMainColor()}`;
    return `  height: 15px; width: 26px;padding-left: 3px;border-radius: 5px;font-size: 12px;background-color:#${this.companyParamsService.getMainColor()}`;
  }
  getStyleSizeRating(): string {
    if (this.size == 'small') return ` margin-top:4px; height: 13px; width: 23px;padding-left: 4px;border-radius: 4px;font-size: 11px; background-color:#e9ecef`;
    return `  height: 15px; width: 26px;padding-left: 3px;border-radius: 5px;font-size: 12px;background-color:#e9ecef`;
  }

  getContainerRating(): string {
    if (this.align == 'right') return 'display: flex; flex-direction: row; justify-content: end;gap: 5px;';
    return 'display: flex; flex-direction: row; gap: 5px;';
  }

}
